export const txtGalleryTitle = {
  id: "Momen Kami",
  en: "Our Moments",
};
